import React from 'react';
import { Row } from 'antd';
import moment from 'moment';
import Text from 'antd/lib/typography/Text';
import Form, { FormInstance } from 'antd/lib/form';

import FormInput from 'components/FormInput';
import Value from 'components/Value';
import { toCurrency } from 'utils/utils';
import { shouldUpdateCompare } from '../../../../utils/utils2';
import NettingList from 'pages/Payment/PAYNetting/NettingList';
import Title from 'components/Title';

type TabClientInvoiceNettingProps = {
  form: FormInstance;
  ciid?: number;
  refetchNetting?: Boolean;
  showAsModal?: Boolean;
  isActive?: boolean;
};

const TabClientInvoiceNetting = ({form,ciid,refetchNetting,showAsModal,isActive}: TabClientInvoiceNettingProps) => {
  return (
    
    <div style={{ backgroundColor: '#f7f7f7', padding: 5 }}>
      <Title comcode="Netting" level={5}></Title>
      <div style={{ padding: 20, background: 'white' }}>
        <div></div>
        <Row>
          <Form.Item noStyle shouldUpdate={shouldUpdateCompare('statuslabel')}>
            {({ getFieldValue }) => (
              <FormInput
                name="statuslabel"
                style={{ color: 'green' }}
                col
                xl={6}
                lg={4}
                md={12}
                sm={24}
              >
                <Text>
                  {getFieldValue('statuslabel')}{' '}
                  {getFieldValue('updated_at')
                    ? moment(getFieldValue('updated_at')).format('YYYY-MM-DD')
                    : null}
                </Text>
              </FormInput>
            )}
          </Form.Item>
          <FormInput
            name="cigrosstotal"
            style={{ color: 'blue' }}
            col
            xl={3}
            lg={4}
            md={12}
            sm={24}
            shouldUpdate={shouldUpdateCompare('currcode')}
          >
            <Value
              formatter={(value) =>
                toCurrency(value, form.getFieldValue('currcode'))
              }
            />
          </FormInput>
          <FormInput
            name="cidueamount"
            style={{ color: 'red' }}
            col
            xl={3}
            lg={4}
            md={12}
            sm={24}
            shouldUpdate={shouldUpdateCompare('currcode')}
          >
            <Value
              formatter={(value) =>
                toCurrency(value, form.getFieldValue('currcode'))
              }
            />
          </FormInput>
        </Row>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            return (
              <NettingList
                ismodal={showAsModal ? true : false}
                refetchNetting={refetchNetting}
                hideExtraAction
                hideFilters
                objectid={
                  getFieldValue('flagcn')
                    ? getFieldValue('ciidcreditnote')
                    : ciid
                }
                hideCol
                objecttype="CINVOICE"
                isActive={isActive}
              />
            );
          }}
        </Form.Item>
      </div>
    </div>
  );
};

export default TabClientInvoiceNetting;
